import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('DistributionChannel?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('DistributionChannel/show/'+id);
    },    
    create(params) {
        return Service().post('DistributionChannel/create', params);
    },
    update(id, params) {
        return Service().post('DistributionChannel/update/'+id, params);
    },
    delete(id) {
        return Service().post('DistributionChannel/delete/'+id);
    }
}